<template>
    <div class="row q-col-gutter-md">
        <div class="col-12">
            <q-input  :readonly="showEdit"  filled dense v-model="paciente.nombres" label="Nombre(s)" />
        </div>
        <div class="col-12">
            <q-input  :readonly="showEdit"  filled dense v-model="paciente.apellidoPaterno" label="Apellido Paterno" />
        </div>
        <div class="col-12">
            <q-input  :readonly="showEdit"  filled dense v-model="paciente.apellidoMaterno" label="Apellido Materno" />
        </div>
        <div class="col-12">
            <q-select filled dense v-model="paciente.hospitalProcedencia" :options="itemsUniversidades" label="Hospital de Procedencia" />
        </div>
        <div class="col-12">
            <q-input filled dense v-model="paciente.diagnostico" autogrow label="Diagnóstico" />
        </div>
        <div class="col-6">
            <q-input filled dense v-model="paciente.telefono" label="Teléfono" mask="(###) ### - ####" />
        </div>
        <div class="col-6">
            <q-input filled dense v-model="paciente.celular" label="Celular" mask="(###) ### - ####" />
        </div>
        <div class="col-12">
            <q-input filled dense v-model="paciente.direccion" label="Dirección" />
        </div>
    </div>
</template>

<script setup>  
import { ref } from "vue";
import { useStore } from 'vuex'
import { computed } from 'vue'
import axios from 'axios'
import { Notify, useQuasar, QSpinnerFacebook } from 'quasar'
const $q = useQuasar()
const store = useStore()

const itemsUniversidades = ref([
    'HOSPITAL INTEGRAL DE NUEVO IDEAL',
    'HOSPITAL INTEGRAL DE CANATLÁN',
    'HOSPITAL GENERAL DE LERDO',
    'HOSPITAL NUEVO GÓMEZ PALACIO',
    'HOSPITAL GENERAL 450',
    'HOSPITAL MATERNO INFANTIL',
    'HOSPITAL DE SALUD MENTAL'
])

const paciente = computed({
    get: () => store.state.pacienteStore,
    set: (val) => store.state.pacienteStore = val
})

const showEdit = computed(() => {
  return !!store.state.pacienteStore?.id
})

</script>